module.exports = __webpack_public_path__ + "static/media/leaves.e102bc95.png";